(function () {
  'use strict';

  var header       = document.getElementById('site-header');
  var burger       = header && header.querySelector('.site-header__burger');
  var drawer       = document.getElementById('nav-drawer');
  var searchToggle = header && header.querySelector('.site-header__search-toggle');
  var searchBar    = document.getElementById('header-search');
  var searchClose  = searchBar && searchBar.querySelector('.site-header__search-close');
  var searchInput  = document.getElementById('header-search-input');
  var searchResults = document.getElementById('predictive-search-results');
  var cartToggle   = header && header.querySelector('.site-header__cart-toggle');

  if (header) {
    var updateHeaderHeight = function () {
      document.documentElement.style.setProperty(
        '--header-total-height',
        header.getBoundingClientRect().height + 'px'
      );
    };
    updateHeaderHeight();
    if (window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(header);
  }

  (function () {
    var hero = document.querySelector('[data-hero]');
    if (!header || !hero || !document.body.classList.contains('template-index')) return;

    var announce = document.querySelector('.announcement-bar');
    var setAnnounce = function () {
      var h = announce ? announce.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    };
    setAnnounce();
    if (window.ResizeObserver && announce) new ResizeObserver(setAnnounce).observe(announce);

    var ticking = false;
    var sync = function () {
      ticking = false;
      /* Theme-Editor: ein Re-Render der Hero-Section ersetzt das Element. Die
         alte Referenz haengt dann nicht mehr im DOM (Rect = 0 -> Header
         faelschlich solid, Ton vom alten Element) - daher frisch holen. */
      if (!hero || !document.documentElement.contains(hero)) {
        hero = document.querySelector('[data-hero]');
      }
      if (!hero) {
        header.classList.add('is-solid');
        header.classList.remove('header-on-light', 'is-glass');
        return;
      }
      var headerH = header.getBoundingClientRect().height;
      var rect = hero.getBoundingClientRect();
      var isSolid = rect.bottom <= headerH + 1;
      header.classList.toggle('is-solid', isSolid);
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 4;
      /* Slide-bewusst: heller Slide-Text (= dunkles Motiv) -> Header bleibt
         weiss, solange er ueber der Hero liegt. Nur auf hellen Motiven
         (dunkler Slide-Text) wechselt er beim Scrollen auf dunkel. */
      var heroLight = hero.getAttribute('data-active-light-text') !== '0';
      header.classList.toggle('header-on-light', !isSolid && scrolled && !heroLight);
      /* Dritter Zustand zwischen transparent und weiss: sobald ueber der Hero
         gescrollt wird, legt sich Milchglas unter den Header - die Navigation
         bleibt ueber bewegtem Video/Foto lesbar, ohne den transparenten
         Ersteindruck aufzugeben. Die Tonalitaet uebernimmt header-on-light. */
      header.classList.toggle('is-glass', !isSolid && scrolled);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    };
    sync();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* Slide-Wechsel (auch ohne Scroll, z.B. Autoplay) -> Ton neu bewerten */
    document.addEventListener('hero:slidechange', onScroll);
  })();

  var drawerTrigger    = null;
  var openSection      = null;
  var levelStack       = [];
  var activeLevel      = null;
  var closeResetTimer  = null;

  /* Ab Desktop laufen die Ebenen als Spalten NEBENEINANDER (Finder-Prinzip):
     Klick auf "Hund" schiebt Spalte 2 rechts daneben, Klick auf "Schlafplatz"
     Spalte 3 - kein Zurueckspringen noetig. Darunter bleibt der erprobte
     Ebenenwechsel mit Zurueck-Button unveraendert. */
  var columnsQuery = window.matchMedia('(min-width: 1024px)');
  function columnsMode() { return columnsQuery.matches; }
  function syncColumnsClass() {
    if (drawer) drawer.classList.toggle('nav-drawer--columns', columnsMode());
  }

  function cssEscape(s) {
    s = String(s == null ? '' : s);
    return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/["\\]/g, '\\$&');
  }

  var navScrollY = 0;
  function lockScroll() {
    if (document.body.dataset.navScrollLocked === '1') return;
    navScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + navScrollY + 'px';
    document.body.style.left     = '0';
    document.body.style.right    = '0';
    document.body.style.width    = '100%';
    document.body.dataset.navScrollLocked = '1';
  }
  function unlockScroll(skipScrollRestore) {
    if (document.body.dataset.navScrollLocked !== '1') return;
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.left     = '';
    document.body.style.right    = '';
    document.body.style.width    = '';
    delete document.body.dataset.navScrollLocked;
    if (!skipScrollRestore) window.scrollTo(0, navScrollY);
  }

  var NAV_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function getNavFocusables() {
    var panel = drawer && drawer.querySelector('.nav-drawer__panel');
    if (!panel) return [];
    return Array.prototype.filter.call(
      panel.querySelectorAll(NAV_FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
  }
  function handleNavTab(e) {
    if (e.key !== 'Tab') return;
    var list = getNavFocusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last  = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function getRootLevel() {
    return drawer && drawer.querySelector('[data-level="root"]');
  }

  function updateDrawerHeader(levelEl) {
    var isRoot  = !levelEl || levelEl.dataset.level === 'root';
    var logoEl  = drawer && drawer.querySelector('[data-drawer-logo]');
    var labelEl = drawer && drawer.querySelector('[data-drawer-section-label]');
    if (logoEl)  logoEl.style.display  = isRoot ? '' : 'none';
    if (labelEl) {
      labelEl.style.display = isRoot ? 'none' : '';
      if (!isRoot) labelEl.textContent = (levelEl && levelEl.dataset.levelTitle) || '';
    }
  }

  function showLevel(nextEl, direction) {
    if (!nextEl) return;
    if (activeLevel && activeLevel !== nextEl) {
      activeLevel.hidden = true;
      activeLevel.classList.remove('is-enter-forward', 'is-enter-back');
    }
    nextEl.removeAttribute('hidden');
    nextEl.classList.remove('is-enter-forward', 'is-enter-back');
    void nextEl.offsetWidth;
    nextEl.classList.add(direction === 'back' ? 'is-enter-back' : 'is-enter-forward');
    activeLevel = nextEl;
    updateDrawerHeader(nextEl);
  }

  /* Tiefe aus dem Level-Index: "0" -> 1 (zweite Spalte), "0-1" -> 2 (dritte). */
  function levelDepth(levelIndex) {
    return String(levelIndex).split('-').length;
  }

  /* Spaltenmodus: Ebene rechts anhaengen, statt die aktuelle zu ersetzen.
     Alles, was tiefer liegt als die neue Spalte, wird vorher geschlossen -
     ein Klick auf "Katze" in Spalte 1 raeumt also Spalte 2 und 3 ab. */
  function openColumn(target, depth, btn) {
    drawer.querySelectorAll('.nav-drawer__level').forEach(function (el) {
      var lvl = el.dataset.level;
      if (lvl === 'root') return;
      if (levelDepth(lvl) >= depth && el !== target) {
        el.hidden = true;
        el.classList.remove('is-enter-forward', 'is-enter-back');
        /* Markierung der geschlossenen Ebene mitnehmen - sonst bleibt sie
           stehen und zeigt beim erneuten Oeffnen einen Pfad an, der gar
           nicht mehr offen ist (Hund > Schlafplatz, dann Katze). */
        el.querySelectorAll('.is-active').forEach(function (a) {
          a.classList.remove('is-active');
        });
      }
    });
    target.removeAttribute('hidden');
    target.classList.remove('is-enter-forward', 'is-enter-back');

    /* Aktiven Pfad markieren: pro Spalte nur ein Eintrag. */
    if (btn && btn.parentNode) {
      btn.parentNode.querySelectorAll('.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    }

    var panel = drawer.querySelector('.nav-drawer__panel');
    if (panel) panel.style.setProperty('--nav-cols', depth + 1);
    activeLevel = target;
  }

  function navigateForward(btn) {
    var levelIndex = btn.dataset.levelIndex;
    if (levelIndex == null) return;
    var target = drawer.querySelector('[data-level="' + levelIndex + '"]');
    if (!target) return;

    if (columnsMode()) {
      openSection = btn.dataset.levelTitle || null;
      openColumn(target, levelDepth(levelIndex), btn);
      return;
    }

    levelStack.push(activeLevel);
    openSection = btn.dataset.levelTitle || null;
    showLevel(target, 'forward');
    setTimeout(function () {
      var panel = drawer.querySelector('.nav-drawer__panel');
      if (panel) panel.focus({ preventScroll: true });
    }, 60);
  }

  function navigateBack() {
    var prev = levelStack.pop() || getRootLevel();
    openSection = (prev && prev.dataset.level === 'root') ? null : (prev && prev.dataset.levelTitle) || null;
    showLevel(prev, 'back');
  }

  function resetToRoot() {
    if (!drawer) return;
    var root = getRootLevel();
    drawer.querySelectorAll('.nav-drawer__level').forEach(function (el) {
      if (el === root) {
        el.removeAttribute('hidden');
        el.classList.remove('is-enter-forward', 'is-enter-back');
      } else {
        el.hidden = true;
        el.classList.remove('is-enter-forward', 'is-enter-back');
      }
    });
    activeLevel  = root;
    levelStack   = [];
    openSection  = null;
    updateDrawerHeader(root);

    /* Spaltenmodus zuruecksetzen: wieder eine Spalte, kein Pfad markiert. */
    var panel = drawer.querySelector('.nav-drawer__panel');
    if (panel) panel.style.setProperty('--nav-cols', 1);
    drawer.querySelectorAll('.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  function openDrawer(section, triggerEl) {
    if (!drawer) return;
    clearTimeout(closeResetTimer);
    drawerTrigger = triggerEl || burger;
    syncColumnsClass();
    resetToRoot();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    lockScroll();

    if (section) {
      var fwdBtn = drawer.querySelector('[data-nav-forward][data-level-title="' + cssEscape(section) + '"]');
      if (fwdBtn) setTimeout(function () { navigateForward(fwdBtn); }, 60);
    } else {
      setTimeout(function () {
        var panel = drawer.querySelector('.nav-drawer__panel');
        if (panel) panel.focus({ preventScroll: true });
      }, 360);
    }
  }

  function closeDrawer(skipScrollRestore) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (header) {
      header.querySelectorAll('[data-drawer-section]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
    unlockScroll(skipScrollRestore);
    if (drawerTrigger) drawerTrigger.focus();
    drawerTrigger = null;
    openSection   = null;
    closeResetTimer = setTimeout(resetToRoot, 380);
  }

  if (burger) {
    burger.addEventListener('click', function () { openDrawer(null, burger); });
  }

  if (header) {
    header.querySelectorAll('[data-drawer-section]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.dataset.drawerSection;
        var isOpen  = drawer && drawer.classList.contains('is-open');

        if (isOpen && openSection === section) {
          closeDrawer();
        } else if (isOpen) {
          clearTimeout(closeResetTimer);
          header.querySelectorAll('[data-drawer-section]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
          btn.setAttribute('aria-expanded', 'true');
          drawerTrigger = btn;
          resetToRoot();
          var fwdBtn = drawer.querySelector('[data-nav-forward][data-level-title="' + cssEscape(section) + '"]');
          if (fwdBtn) setTimeout(function () { navigateForward(fwdBtn); }, 60);
          openSection = section;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          openDrawer(section, btn);
        }
      });
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-nav-close]');
      if (closer) {
        var href = closer.tagName === 'A' && closer.getAttribute('href');
        var isNavLink = !!(href && href.charAt(0) !== '#');
        closeDrawer(isNavLink);
        return;
      }
      var fwdBtn  = e.target.closest('[data-nav-forward]');
      var backBtn = e.target.closest('[data-nav-back]');
      if (fwdBtn)  navigateForward(fwdBtn);
      if (backBtn) navigateBack();
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); }
      else handleNavTab(e);
    });

    /* Wechsel Desktop <-> Mobil: Spalten und Ebenenwechsel schliessen sich aus,
       deshalb bei offenem Drawer auf die Wurzel zuruecksetzen statt einen
       halb offenen Mischzustand stehen zu lassen. */
    var onColumnsChange = function () {
      syncColumnsClass();
      if (drawer.classList.contains('is-open')) resetToRoot();
    };
    if (columnsQuery.addEventListener) columnsQuery.addEventListener('change', onColumnsChange);
    else if (columnsQuery.addListener) columnsQuery.addListener(onColumnsChange);
    syncColumnsClass();
  }

  var desktopSearchMQ    = window.matchMedia('(min-width: 1024px)');

  function isDesktopSearch() { return desktopSearchMQ.matches; }

  function openMobileSearch() {
    if (!searchBar || !header) return;
    header.classList.add('is-search-open');
    searchBar.setAttribute('aria-hidden', 'false');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 60);
  }
  function closeMobileSearch() {
    if (!searchBar || !header) return;
    header.classList.remove('is-search-open');
    searchBar.setAttribute('aria-hidden', 'true');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
    clearTimeout(searchTimeout);
    if (searchController) searchController.abort();
    if (searchResults) searchResults.innerHTML = '';
    if (searchInput) searchInput.blur();
  }

  function syncDesktopSearch() {
    if (!header) return;
    if (!isDesktopSearch()) {
      header.classList.remove('is-search-collapsed');
      return;
    }
    header.classList.remove('is-search-open');

    var focused = !!(searchInput && document.activeElement === searchInput);

    var shouldOpen = focused;
    header.classList.toggle('is-search-collapsed', !shouldOpen);
    if (searchBar) searchBar.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    searchToggle && searchToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      if (isDesktopSearch()) {
        header.classList.remove('is-search-collapsed');
        if (searchBar) searchBar.setAttribute('aria-hidden', 'false');
        if (searchInput) searchInput.focus();
      } else if (header.classList.contains('is-search-open')) {
        closeMobileSearch();
      } else {
        openMobileSearch();
      }
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      if (isDesktopSearch()) {
        if (searchInput) { searchInput.value = ''; searchInput.blur(); }
        if (searchResults) searchResults.innerHTML = '';
        syncDesktopSearch();
      } else {
        closeMobileSearch();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) return;
    if (document.querySelector('.oscar.is-open')) return;
    if (isDesktopSearch()) {
      if (searchInput) { searchInput.value = ''; searchInput.blur(); }
      if (searchResults) searchResults.innerHTML = '';
      syncDesktopSearch();
    } else if (header && header.classList.contains('is-search-open')) {
      closeMobileSearch();
    }
  });

  var searchTicking = false;
  function onSearchScroll() {
    if (searchTicking) return;
    searchTicking = true;
    requestAnimationFrame(function () { searchTicking = false; syncDesktopSearch(); });
  }
  window.addEventListener('resize', onSearchScroll, { passive: true });
  if (desktopSearchMQ.addEventListener) desktopSearchMQ.addEventListener('change', syncDesktopSearch);
  if (searchInput) {
    searchInput.addEventListener('focus', syncDesktopSearch);
    searchInput.addEventListener('blur', function () { setTimeout(syncDesktopSearch, 120); });
  }
  syncDesktopSearch();

  if (searchInput && searchResults) {
    var searchController = null;
    var searchTimeout    = null;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function imgUrl(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    function aiEndpoint() {
      var el = document.querySelector('[data-oscar][data-endpoint]');
      var ep = (el && el.getAttribute('data-endpoint')) || 'https://api.paw.de';
      return ep.replace(/\/+$/, '');
    }
    function aiText(name, fallback) {
      return (searchResults && searchResults.getAttribute('data-ai-' + name)) || fallback;
    }
    function searchPageUrl() {
      var form = header && header.querySelector('.site-header__search-form');
      return (form && form.getAttribute('action')) || '/search';
    }

    function renderAiResults(data) {
      var items = data.products.slice(0, 6).map(function (p) {
        var img = p.image
          ? '<img src="' + esc(imgUrl(p.image, 120)) + '" alt="' + esc(p.title) +
            '" width="56" height="56" loading="lazy" decoding="async">'
          : '';
        var vendor = p.vendor ? '<p class="ps__vendor">' + esc(p.vendor) + '</p>' : '';
        var price  = p.price  ? '<p class="ps__price">'  + esc(p.price)  + '</p>' : '';
        return '<li role="option"><a href="' + esc(p.url) + '" class="ps__item">' +
          '<div class="ps__img">' + img + '</div>' +
          '<div class="ps__info">' + vendor +
          '<p class="ps__title">' + esc(p.title) + '</p>' + price +
          '</div></a></li>';
      }).join('');
      var term = data.term || data.query || '';
      var allUrl = searchPageUrl() + '?q=' + encodeURIComponent(term) + '&type=product';
      return '<div class="ps">' +
        '<p class="ps__heading">' + esc(aiText('did-you-mean', 'Meinten Sie:')) + ' ' + esc(term) + '</p>' +
        '<ul class="ps__list" role="listbox">' + items + '</ul>' +
        '<a href="' + esc(allUrl) + '" class="ps__all">' + esc(aiText('all-results', 'Alle Ergebnisse ansehen')) + '</a>' +
        '</div>';
    }

    /* Grundpreis (PAngV) fuer die KI-Treffer: Der Worker liefert keine
       Grundpreis-Daten. Pro Treffer mit Preis rendert die Section
       product-unit-price (Section Rendering API) den Grundpreis serverseitig
       ueber snippets/unit-price.liquid - gleiches Format und dieselben Locales
       wie Karte und Suche. Ohne Grundpreis liefert sie nichts -> keine Zeile.
       Zuordnung ueber die Reihenfolge: renderAiResults() rendert dieselbe Liste. */
    function loadAiUnitPrices(products, signal) {
      var rows = searchResults.querySelectorAll('.ps__item');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      products.forEach(function (p, i) {
        var row = rows[i];
        var m = /\/products\/([^/?#]+)/.exec(p.url || '');
        if (!row || !m || !p.price) return;
        fetch(root + 'products/' + m[1] + '?section_id=product-unit-price', { signal: signal })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html || !row.isConnected) return;
            var unit = new DOMParser().parseFromString(html, 'text/html').querySelector('.unit-price');
            var price = row.querySelector('.ps__price');
            if (unit && price) price.insertAdjacentElement('afterend', document.importNode(unit, true));
          })
          .catch(function () {});
      });
    }

    function aiFallback(q, signal) {
      var endpoint = aiEndpoint();
      if (!endpoint) return;
      searchResults.innerHTML =
        '<div class="ps ps--ai-loading"><span class="ps__spin" aria-hidden="true"></span>' +
        '<p>' + esc(aiText('loading', 'Einen Moment, ich verstehe Ihre Suche …')) + '</p></div>';
      fetch(endpoint + '/search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: q }),
        signal: signal
      })
        .then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (!data || !Array.isArray(data.products) || !data.products.length) {
            searchResults.innerHTML =
              '<div class="ps ps--empty"><p>Leider keine Treffer. Versuchen Sie es mit einem anderen Begriff.</p></div>';
            return;
          }
          searchResults.innerHTML = renderAiResults(data);
          loadAiUnitPrices(data.products.slice(0, 6), signal);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          searchResults.innerHTML =
            '<div class="ps ps--empty"><p>' +
            esc(aiText('error', 'Die Suche ist gerade nicht erreichbar. Bitte versuchen Sie es gleich noch einmal.')) +
            '</p></div>';
        });
    }

    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var q = searchInput.value.trim();
      if (!q) {
        if (searchController) searchController.abort();
        searchResults.innerHTML = '';
        return;
      }

      searchTimeout = setTimeout(function () {
        if (searchController) searchController.abort();
        searchController = new AbortController();
        var ctrl = searchController;
        /* Locale-Root (z. B. "/en/"): ohne Praefix liefert der Endpunkt auf /en
           deutsche Treffer mit DE-Produktlinks. routes.root endet immer auf "/". */
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc   = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#shopify-section-predictive-search');
            if (inner) searchResults.innerHTML = inner.innerHTML;
            if (searchResults.querySelector('.ps--empty')) {
              aiFallback(q, ctrl.signal);
            }
          })
          .catch(function () {});
      }, 250);
    });
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  }

  document.addEventListener('cart:updated', function (e) {
    var count = document.getElementById('cart-count');
    if (!count) return;
    var n = (e.detail && (e.detail.item_count != null ? e.detail.item_count : e.detail.itemCount)) || 0;
    count.textContent = n > 0 ? String(n) : '';
  });

})();
